import React from 'react';

import { COLOR } from '@/theme/colors';
import { SVGIconProps } from '@/types/svg';

const EquinetPremium: React.FC<SVGIconProps> = ({
    width = 240,
    color = COLOR.deepCerulean,
}) => {
    return (
        <svg
            id="Layer_2"
            data-name="Layer 2"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 240 65.59"
            width={width}
        >
            <g id="Layer_1" data-name="Layer 1">
                <g>
                    <path
                        fill={color}
                        d="M65.59,32.8C65.59,14.68,50.91,0,32.8,0S0,14.68,0,32.8s14.68,32.8,32.8,32.8,32.8-14.68,32.8-32.8"
                    />
                    <path
                        fill={COLOR.white}
                        d="M20.98,47.01c-4.66,1.6-7.23.38-7.23.38l-5.55-11s3.02.79,7.16-2.59c4.16-3.39,9.2-18.96,9.2-18.96l8.24,16.33s-6.69,14.05-11.82,15.84"
                    />
                    <path
                        fill={COLOR.white}
                        d="M44.62,47.01c4.66,1.6,7.24.38,7.24.38l5.54-11s-3.02.79-7.16-2.59c-4.14-3.39-9.19-18.96-9.19-18.96l-8.24,16.33s6.7,14.05,11.82,15.84"
                    />
                    <path
                        fill={COLOR.white}
                        d="M32.8,64.1c-17.26,0-31.3-14.04-31.3-31.3S15.54,1.5,32.8,1.5s31.3,14.04,31.3,31.3-14.04,31.3-31.3,31.3M32.8,2.83C16.28,2.83,2.83,16.28,2.83,32.8s13.44,29.96,29.96,29.96,29.96-13.44,29.96-29.96S49.32,2.83,32.8,2.83"
                    />
                    <polygon
                        fill={color}
                        points="99.28 15.02 99.28 18.6 86.5 18.6 86.5 21.32 98.54 21.32 98.54 24.45 86.5 24.45 86.5 27.24 99.44 27.24 99.44 30.82 81.76 30.82 81.76 15.02 99.28 15.02"
                    />
                    <path
                        fill={color}
                        d="M126.1,27.72l-1.68,3.25-1.87-1.37c-.66.57-1.45.9-2.61,1.14-.97.21-2.49.26-6.56.26-3.32,0-5.71-.09-6.61-.26-1.75-.33-2.75-1-3.37-2.16-.57-1.14-.73-2.28-.73-5.33s.05-3.74.36-4.83c.45-1.68,1.37-2.58,3.18-3.11,1.19-.33,2.7-.45,5.69-.45,5.95,0,7.58.07,8.86.4,1.73.43,2.7,1.37,3.18,3.13.26.85.33,1.87.33,4.36,0,2.09-.05,2.77-.21,3.79l2.06,1.19ZM119.44,23.83c.02-.59.02-.85.02-1.26,0-3.82-.07-3.86-6.47-3.86-5.24,0-5.47.17-5.47,4.2,0,2.44.24,3.32.97,3.72.85.45,1.52.5,6.07.5,1.97,0,2.84-.05,3.58-.19l-5.24-2.92,1.9-3.2,4.64,3.01Z"
                    />
                    <path
                        fill={color}
                        d="M133.5,15.02v7.82c0,1.73,0,1.78.07,2.2.24,1.78,1.02,2.13,4.62,2.13s4.6-.09,5.19-.55c.47-.36.71-1.04.73-2.25q.02-.36.02-2.11v-7.25h4.81v8.29c.05,3.91-.28,5.07-1.68,6.33-1.14.88-2.56,1.26-4.62,1.28-.73.02-1.16.02-2.11.02l-1.8.02c-4.46-.02-5.33-.07-6.49-.38-2.87-.88-3.63-2.37-3.56-7.06v-8.51h4.81Z"
                    />
                    <rect
                        fill={color}
                        x="152.93"
                        y="15.02"
                        width="4.81"
                        height="15.81"
                    />
                    <polygon
                        fill={color}
                        points="161.86 15.02 169.52 15.02 179.09 27.03 178.98 15.02 183.53 15.02 183.53 30.82 175.8 30.82 166.37 18.93 166.49 30.82 161.86 30.82 161.86 15.02"
                    />
                    <polygon
                        fill={color}
                        points="205.14 15.02 205.14 18.6 192.37 18.6 192.37 21.32 204.4 21.32 204.4 24.45 192.37 24.45 192.37 27.24 205.3 27.24 205.3 30.82 187.63 30.82 187.63 15.02 205.14 15.02"
                    />
                    <polygon
                        fill={color}
                        points="215.04 18.93 208.01 18.93 208.01 15.02 226.89 15.02 226.89 18.93 219.86 18.93 219.86 30.82 215.04 30.82 215.04 18.93"
                    />
                    <path
                        fill={color}
                        d="M81.76,36.14h12.09c3.06,0,3.84.09,4.83.59,1.59.78,2.18,2.23,2.18,5.21s-.54,4.57-1.85,5.38c-.92.57-1.99.73-4.74.73h-7.73v3.89h-4.79v-15.81ZM93.54,44.22c1.97,0,2.54-.43,2.54-1.92,0-1.9-.47-2.32-2.54-2.32h-6.99v4.24h6.99Z"
                    />
                    <path
                        fill={color}
                        d="M104.28,36.14h13.63c2.8,0,4.03.24,4.93,1,.92.73,1.35,2.08,1.35,4.22,0,2.94-.71,4.1-2.72,4.55,1.97.33,2.56,1.16,2.51,3.56v2.49h-4.88v-1.97c-.02-1.71-.5-2.06-2.65-2.01h-7.37v3.98h-4.79v-15.81ZM116.58,44.11c2.32,0,2.77-.28,2.77-1.85,0-1.02-.09-1.45-.4-1.78-.36-.38-.76-.45-2.2-.45h-7.68v4.08h7.51Z"
                    />
                    <polygon
                        fill={color}
                        points="145.58 36.14 145.58 39.72 132.81 39.72 132.81 42.45 144.85 42.45 144.85 45.57 132.81 45.57 132.81 48.37 145.75 48.37 145.75 51.95 128.07 51.95 128.07 36.14 145.58 36.14"
                    />
                    <polygon
                        fill={color}
                        points="149.3 36.14 156.94 36.14 162.69 46.64 168.43 36.14 176.01 36.14 176.01 51.95 171.32 51.95 171.56 39.75 164.54 51.95 160.7 51.95 153.81 39.75 153.95 51.95 149.3 51.95 149.3 36.14"
                    />
                    <rect
                        fill={color}
                        x="180.14"
                        y="36.14"
                        width="4.81"
                        height="15.81"
                    />
                    <path
                        fill={color}
                        d="M193.86,36.14v7.82c0,1.73,0,1.78.07,2.2.24,1.78,1.02,2.13,4.62,2.13s4.6-.09,5.19-.55c.47-.36.71-1.04.73-2.25q.02-.36.02-2.11v-7.25h4.81v8.29c.05,3.91-.28,5.07-1.68,6.33-1.14.88-2.56,1.26-4.62,1.28-.73.02-1.16.02-2.11.02l-1.8.02c-4.46-.02-5.33-.07-6.49-.38-2.87-.88-3.63-2.37-3.56-7.06v-8.51h4.81Z"
                    />
                    <polygon
                        fill={color}
                        points="213.29 36.14 220.92 36.14 226.68 46.64 232.42 36.14 240 36.14 240 51.95 235.31 51.95 235.55 39.75 228.53 51.95 224.69 51.95 217.79 39.75 217.94 51.95 213.29 51.95 213.29 36.14"
                    />
                </g>
            </g>
        </svg>
    );
};

export default EquinetPremium;
